// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__ipmFe","loader":"loader_loader__1AOoV","loaderLogo":"loader_loaderLogo__Ta+Sf","ldsEclipse":"loader_ldsEclipse__Qujh+"};